import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FavouriteCurrencyMode } from '../../../models/filter-models';
import { AutocompleteComponent, AutocompleteOption } from '../../../common/autocomplete/autocomplete.component';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { BaseComponent } from '../../../common/base.component';

@Component({
  selector: 'app-favourite-basic-currency-filter',
  imports: [FormsModule, AutocompleteComponent, SelectComponent, SelectOptionComponent],
  templateUrl: './favourite-basic-currency-filter.component.html',
  styleUrl: './favourite-basic-currency-filter.component.scss'
})
export class FavouriteBasicCurrencyFilterComponent extends BaseComponent {
  enabled = input(false);
  label = input('Basic Currency');
  baseTypeOptions = input<AutocompleteOption[]>([]);
  baseTypes = input<string[]>([]);
  mode = input(FavouriteCurrencyMode.Multiplier);
  value = input<number | null>(null);

  enabledToggled = output<void>();
  baseTypesChange = output<string[]>();
  modeChange = output<FavouriteCurrencyMode>();
  valueChange = output<number | null>();

  FavouriteCurrencyMode = FavouriteCurrencyMode;

  isRowInactive = (): boolean => !this.enabled();

  // 'None' selected means the row has no effect, even though it's toggled on
  looksInactive = (): boolean => this.isRowInactive() || this.baseTypes().length === 0 || (this.baseTypes().length === 1 && this.baseTypes()[0] === 'None');
}
